import React, { StrictMode, Component } from 'react'
import { createRoot } from 'react-dom/client'
import './i18n'
import './index.css'
import App from './App.jsx'

if (typeof document !== 'undefined') {
  document.title = 'Geppetto Creator — cursos para Moodle';
}

// #region agent log
const _dbgPost = (payload) => {
  fetch('http://127.0.0.1:7775/ingest/55db32bd-4781-4427-95f3-92604cc97efe', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': 'e671dc' },
    body: JSON.stringify({ sessionId: 'e671dc', timestamp: Date.now(), ...payload }),
  }).catch(() => {})
}
window.addEventListener('error', (ev) => {
  _dbgPost({
    location: 'main.jsx:window.error',
    message: 'window error',
    hypothesisId: 'H2',
    data: { msg: String(ev?.message || ''), filename: ev?.filename, lineno: ev?.lineno, colno: ev?.colno, stack: ev?.error?.stack ? String(ev.error.stack).slice(0, 2500) : '' },
  })
})
window.addEventListener('unhandledrejection', (ev) => {
  const r = ev?.reason
  _dbgPost({
    location: 'main.jsx:unhandledrejection',
    message: 'unhandled rejection',
    hypothesisId: 'H4',
    data: { reason: r instanceof Error ? r.message : String(r), stack: r instanceof Error ? String(r.stack || '').slice(0, 2500) : '' },
  })
})
_dbgPost({ location: 'main.jsx:boot', message: 'main module loaded', hypothesisId: 'H3', data: { hasRoot: !!document.getElementById('root') } })
// #endregion

class DebugErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { err: null }
  }
  static getDerivedStateFromError(error) {
    return { err: error }
  }
  componentDidCatch(error, info) {
    // #region agent log
    _dbgPost({
      location: 'main.jsx:DebugErrorBoundary',
      message: 'React render error',
      hypothesisId: 'H1',
      data: {
        msg: String(error?.message || error),
        stack: String(error?.stack || '').slice(0, 2500),
        componentStack: String(info?.componentStack || '').slice(0, 1500),
      },
    })
    // #endregion
  }
  render() {
    if (this.state.err) {
      const msg = this.state.err && typeof this.state.err === 'object' && 'message' in this.state.err
        ? String(this.state.err.message)
        : String(this.state.err || '')
      return (
        <div style={{ padding: 24, fontFamily: 'system-ui', maxWidth: '48rem' }}>
          <p style={{ marginBottom: 12 }}>Erro ao renderizar a aplicação (sessão debug e671dc). Detalhe abaixo ajuda a corrigir sem depender do log remoto.</p>
          <pre style={{ fontSize: 13, whiteSpace: 'pre-wrap', wordBreak: 'break-word', padding: 12, background: '#f1f5f9', borderRadius: 8, border: '1px solid #e2e8f0' }}>{msg}</pre>
        </div>
      )
    }
    return this.props.children
  }
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <DebugErrorBoundary>
      <App />
    </DebugErrorBoundary>
  </StrictMode>,
)
